<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="show" :data="model" :title="$t('Tax Status')" @show="onShow" size="sm"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable>
      <input-widget :label="false" :model="model" attribute="tax_status_uuid" type="select2"
                    display-field="${item.name}" :items="taxStatuses"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import TaxStatusForm from "@/modules/customer/models/TaxStatusForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('reservations');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "TaxStatusModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new TaxStatusForm({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['hideTaxStatusModal', 'updateLotTaxStatus']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t("Changing terms will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?"))
        if (!success) {
          return;
        }

        this.loading = true;
        let response = await this.updateLotTaxStatus({
          lotUuid: this.model.lot_uuid,
          data: {tax_status_uuid: this.model.tax_status_uuid}
        });
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideTaxStatusModal();
          this.$toast('success', this.$t('Tax Status was successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new TaxStatusForm();
        this.hideTaxStatusModal(false);
      },
    },
    watch: {
      editObject() {
        this.model = new TaxStatusForm(this.editObject);
      }
    },
    computed: {
      ...globalMapState(['taxStatuses']),
      ...mapState({
        show: state => state.view.termsData.taxStatusModal.show,
        editObject: state => state.view.termsData.taxStatusModal.object,
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

